import { LoadPageAction } from "../../../pillar/common/actions/LoadPageAction";
import { LoadPagePayload } from "../../../pillar/common/actions/LoadPagePayload";

export const QUERY_AVAILABLE_ROLES = "[SecurityModule] Query Available Roles";

export class QueryAvailableRolesAction implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(public payload: LoadPagePayload) {
    this.type = QUERY_AVAILABLE_ROLES;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/QueryAvailableRolesAction.ts